import { render, staticRenderFns } from "./BaseImageTeaser.vue?vue&type=template&id=53f34946&"
import script from "./BaseImageTeaser.vue?vue&type=script&lang=ts&"
export * from "./BaseImageTeaser.vue?vue&type=script&lang=ts&"
import style0 from "./BaseImageTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports